"use strict";
/*
* Created on 20.06.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Stepan Mik
 */


var WindowItemPlacementConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemPlacementConverter, _DataObjectConverter_);

  function WindowItemPlacementConverter() {
    _classCallCheck(this, WindowItemPlacementConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPlacementConverter).apply(this, arguments));
  }

  return WindowItemPlacementConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemPlacementConverter = WindowItemPlacementConverter;